import React from 'react';
import { ClipboardCheck } from 'lucide-react';
import { formatDate } from '../../../lib/format';

const REVIEW_LABEL = {
  daily:   'Daily Review',
  weekly:  'Weekly Review',
  monthly: 'Monthly Review',
};

// Small pill showing where a task came from. Currently only business reviews
// (tasks.business_review_id); renders nothing for ordinary tasks.
export default function TaskSourceTag({ task }) {
  if (!task?.business_review_id) return null;
  const label = REVIEW_LABEL[task.business_review_type] || 'Business Review';
  const title = task.business_review_date
    ? `Created in ${label} · ${formatDate(task.business_review_date)}`
    : `Created in ${label}`;
  return (
    <span className="task-source-tag" title={title}>
      <ClipboardCheck size={11} />
      {label}
    </span>
  );
}
